<template>
  <generic-modal :title="modal_title" ref="generic_modal">
    <form>
      <!-- DPI del Cliente -->
      <div class="field">
        <label class="label">{{ $t("client dpi") }}</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="meta.client_dpi"
            :placeholder="$t('client dpi')"
            maxlength="20"
            required
          />
        </div>
      </div>

      <!-- Email del Cliente -->
      <div class="field">
        <label class="label">{{ $t("client email") }}</label>
        <div class="control">
          <input
            class="input"
            type="email"
            v-model="meta.client_email"
            :placeholder="$t('client email')"
            required
          />
        </div>
      </div>

      <!-- Teléfono del Cliente -->
      <div class="field">
        <label class="label">{{ $t("client phone") }}</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="meta.client_phone"
            :placeholder="$t('client phone')"
            maxlength="20"
          />
        </div>
      </div>

      <!-- Estado (solo al editar) -->
      <div class="field" v-if="entity_uuid">
        <label class="label">{{ $t("status") }}</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="meta.status">
              <option value="pending">{{ $t("pending") }}</option>
              <option value="completed">{{ $t("completed") }}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Notas del Administrador -->
      <div class="field">
        <label class="label">{{ $t("admin notes") }}</label>
        <div class="control">
          <textarea
            class="textarea"
            v-model="meta.admin_notes"
            :placeholder="$t('admin notes')"
            rows="3"
          ></textarea>
        </div>
      </div>
    </form>

    <!-- Mensajes de error -->
    <div class="notification is-danger" v-if="error" v-html="error"></div>

    <!-- PATRÓN CORRECTO: usar v-slot:footer -->
    <template v-slot:footer>
      <button
        class="button is-success"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button" @click="close_modal">
        <span class="icon">
          <i class="fa fa-times"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import { post, put, get, success_message, error_message } from "@/utils";

export default {
  name: "RequestModal",
  components: { GenericModal },
  data() {
    return {
      meta: {
        client_dpi: "",
        client_email: "",
        client_phone: "",
        status: "pending",
        admin_notes: "",
        settings: null,
      },
      error: "",
      entity_uuid: "",
      is_clone: false,
    };
  },
  computed: {
    modal_title() {
      if (this.is_clone) {
        return this.$t("clone request");
      }
      return this.entity_uuid
        ? this.$t("edit request")
        : this.$t("create request");
    },
    is_form_invalid() {
      return (
        !this.meta.client_dpi.trim() ||
        !this.meta.client_email.trim() ||
        !this.is_valid_email(this.meta.client_email)
      );
    },
  },
  methods: {
    show_modal(uuid = null, clone = false) {
      let v = this;
      v.entity_uuid = uuid;
      v.is_clone = clone;
      v.$refs.generic_modal.show_modal();
      if (uuid) {
        v.get_entity(uuid);
      }
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    set_initial_state() {
      this.meta = {
        client_dpi: "",
        client_email: "",
        client_phone: "",
        status: "pending",
        admin_notes: "",
        settings: null,
      };
      this.error = "";
      this.entity_uuid = "";
      this.is_clone = false;
    },
    get_entity(uuid) {
      let v = this;
      get("/account-request/request", { uuid: uuid })
        .then((response) => {
          if (v.is_clone) {
            v.meta = {
              client_dpi: response.client_dpi + " (Copia)",
              client_email: response.client_email,
              client_phone: response.client_phone,
              status: "pending",
              admin_notes: response.admin_notes,
              settings: response.settings,
            };
          } else {
            v.meta = {
              client_dpi: response.client_dpi,
              client_email: response.client_email,
              client_phone: response.client_phone,
              status: response.status,
              admin_notes: response.admin_notes,
              settings: response.settings,
            };
          }
        })
        .catch((error) => {
          v.error = error_message(error);
        });
    },
    save() {
      let v = this;
      if (v.is_form_invalid) {
        v.error = "Por favor complete los campos requeridos";
        return;
      }

      v.error = "";
      let data = { ...v.meta };

      if (v.entity_uuid && !v.is_clone) {
        data.uuid = v.entity_uuid;
        post("/account-request/request", data)
          .then(() => {
            success_message(v.$t("request updated successfully"));
            v.close_modal();
            v.$emit("success");
          })
          .catch((error) => {
            v.error = error;
          });
      } else {
        put("/account-request/request", data)
          .then(() => {
            success_message(v.$t("request created successfully"));
            v.close_modal();
            v.$emit("success");
          })
          .catch((error) => {
            v.error = error;
          });
      }
    },
    is_valid_email(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
  },
};
</script>

<style scoped>
.modal-card {
  width: 600px;
  max-width: 90vw;
}
</style>
